<nb-card>
  <nb-card-header>Prévisualisation de l'image</nb-card-header>
  <nb-card-body>
    <div class="preview-wrapper">
      <!-- Spinner overlay -->
      <div *ngIf="loading" class="spinner-overlay">
        <nb-spinner></nb-spinner>
      </div>

      <!-- Always in DOM so <img> layouts, but fades in after loading -->
      <div *ngIf="phase !== 'SUCCEEDED'" [class.visible]="!loading" class="preview-content">
        <div class="full-container">
          <img
            #image
            [src]="imageUrl"
            alt="Image preview"
            class="image-fit"
            (load)="onImageLoad()"
          />
          <!--<div class="frame"    [ngStyle]="frameStyles"></div>
          <div class="overlay"></div>-->
        </div>

        <div *ngIf="!progressStarted" class="text">
          <br>
          <!--<label style="margin-right: 1rem;">Choisissez un mode d'animation :</label>
          <nb-select [(selected)]="animationMode" size="small">
            <nb-option value="veo">VEO</nb-option>
            <nb-option value="explore">Explore (gratuit, plus lent)</nb-option>
            <nb-option value="fast">Fast (2€ - plus rapide et plus performant)</nb-option>
            <nb-option value="vip">VIP (4€ - le plus performant)</nb-option>
          </nb-select>
          <p><br>Votre image sera automatiquement recadrée.</p>-->
          <div class="prompt-field" style="margin-top: 1rem;">
            <label for="prompt">Prompt (optionnel) :</label>
            <textarea
              id="prompt"
              nbInput
              fullWidth
              rows="3"
              [(ngModel)]="prompt"
              placeholder="Décrivez ici…"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="progressStarted && phase !== 'SUCCEEDED' && !errorMessage" class="progress-container">
      <br>
      <p>{{ activeLabel }} : {{ activeProgress | number:'1.0-1' }}%</p>
    
      <!-- Barre déterminée si on a un pourcentage -->
      <nb-progress-bar *ngIf="phase !== 'GIF_RENDERING' || (phase === 'GIF_RENDERING' && activeProgress > 0)"
                       [value]="activeProgress"
                       status="info">
      </nb-progress-bar>
    
      <!-- Spinner indéterminé si GIF sans pourcentage -->
      <div *ngIf="phase === 'GIF_RENDERING' && activeProgress === 0">
        <nb-spinner></nb-spinner>
      </div>
    </div>
    
    <div *ngIf="phase === 'SUCCEEDED'">
      <p>Animation terminée ! Choisissez votre version préférée :</p>
      <div class="gif-selection">
        <div class="gif-item" *ngFor="let url of gifUrls; let i = index">
          <img 
            [src]="url"
            (click)="onSelectGif(url)"
            class="gif-option" 
          />
          <p class="gif-size">{{ sizes[i] | number }} Mo</p>
        </div>
      </div>
    </div>
    
    
    <div *ngIf="errorMessage" class="error-message">
      <p><br>{{ errorMessage }}</p><br>
      <p>Nous vous invitons à vous rapprocher de votre contact Deebr si l'erreur se reproduit</p>
      <button nbButton (click)="onCancel()">Fermer</button>
    </div>
  </nb-card-body>
  <nb-card-footer class="footer-buttons">
      <button nbButton (click)="onCancel()" *ngIf="!progressStarted || phase === 'SUCCEEDED'">Annuler</button>
      <button nbButton appearance="filled" status="danger" (click)="onValidate()" *ngIf="!progressStarted">Animer</button>
    </nb-card-footer>
</nb-card>

<ng-template #dialogErrorAnimate let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-body class="text-center">{{ errorMessage }} <br>Nous vous invitons à vous rapprocher de votre contact Deebr si l'erreur se reproduit.</nb-card-body>
    <nb-card-footer>
      <div class="row">
        <div class="col text-center">
          <button nbButton status="danger" (click)="closeDialogError()">OK</button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>